import type { Template } from "@/types";

export const PO_01_H0_V1: Template[] = [
{
    id: "po-01-h0v1-01",
    name: "PO 01 - H0V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h0_v1_01.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 693, y: 82, width: 437, height: 688, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h0v1-02",
    name: "PO 02 - H0V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h0_v1_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 650, y: 39, width: 525, height: 774, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h0v1-03",
    name: "PO 03 - H0V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h0_v1_03.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 390, y: 82, width: 437, height: 688, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h0v1-04",
    name: "PO 04 - H0V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h0_v1_04.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 42, y: 39, width: 525, height: 774, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h0v1-05",
    name: "PO 05 - H0V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h0_v1_05.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 86, y: 82, width: 437, height: 688, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h0v1-06",
    name: "PO 06 - H0V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h0_v1_06.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 609, y: 0, width: 608, height: 851, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h0v1-07",
    name: "PO 07 - H0V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h0_v1_07.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 609, y: 0, width: 533, height: 851, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h0v1-08",
    name: "PO 08 - H0V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h0_v1_08.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 608, height: 851, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h0v1-09",
    name: "PO 09 - H0V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h0_v1_09.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 76, y: 0, width: 533, height: 851, rotation: 0, imageRotation: 0 }
    ],
}
];